import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { postRequest } from "../../../axios/axios";
import { toast } from "react-toastify";
import { setPasswordSchema } from "../LoginSchema";
import { useFormik } from "formik";
import { handleIsPasswordCreated } from "../LoginSlice";
import { useDispatch, useSelector } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
const flexClassStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};
const outlinedInputStyle = {
  backgroundColor: "#F9F9F9",
  border: "1px solid #F9F9F9",
  "&.MuiOutlinedInput-root.Mui-disabled": {
    border: "1px solid #F9F9F9",
  },
  "&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline ": {
    border: "1px solid #F9F9F9",
  },
};
const gridMessageStyle = {
  marginTop: "1rem",
  padding: "1rem",
  display: "flex",
  flexDirection: "column",
};
const ResetPassword = (props) => {
  const { userEmail } = props;
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [passLength, setPassLength] = useState(true);
  const [isUpperCharPresent, setIsUpperCharPresent] = useState(true);
  const [isLowerCharPresent, setIsLowerCharPresent] = useState(true);
  const [isNumberIsPresent, setIsNumberIsPresent] = useState(true);
  const [isSpecialCharPresent, setIsSpecialCharPresent] = useState(true);
  const [showPassHint, setShowPassHint] = useState(false);

  const dispatch = useDispatch();

  const getEmailFromRedux = useSelector((state) => {
    return state?.Login?.userDetail?.email;
  });
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  let defaultValue = {
    newPassword: "",
    ConfirmPassword: "",
  };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: defaultValue,
    validationSchema: setPasswordSchema,
    onSubmit: (values) => {
      handleSetNewPassword();
    },
  });
  const { values } = formik;
  const handleSetNewPassword = async () => {
    const toastId = toast.loading("Loading...");
    try {
      const isValid =
        passLength ||
        isUpperCharPresent ||
        isLowerCharPresent ||
        isNumberIsPresent ||
        isSpecialCharPresent;
      if (isValid) {
        setShowPassHint(true);
      } else {
        setShowPassHint(false);
      }
      if (!formik.isValid) return;
      setIsDisabled(true);
      const data = {
        email: getEmailFromRedux ? getEmailFromRedux : userEmail,
        password: values?.ConfirmPassword,
      };
      const res = await postRequest("/api/create/password", data, "sdLogin");
      const { isSuccess, message } = res.data || {};
      if (isSuccess) {
        dispatch(handleIsPasswordCreated(true));
      } else if (!isSuccess) {
        setIsDisabled(false);
        toast.error(message);
      } else {
        setIsDisabled(false);
        toast.error(message);
      }
    } catch (error) {
      toast.error(error?.message);
    } finally {
      toast.dismiss(toastId);
    }
  };

  const handleValidationCheck = (value) => {
    const containsNumber = /\d/;
    const containsSpecialCharacter = /[^a-zA-Z0-9]/;
    const containsUppercase = /[A-Z]/;
    const containsLowerCase = /[a-z]/;
    if (value?.length === 0) {
      setIsNumberIsPresent(true);
      setIsSpecialCharPresent(true);
      setIsUpperCharPresent(true);
      setIsLowerCharPresent(true);
      setPassLength(true);
    }
    if (containsNumber.test(value)) {
      setIsNumberIsPresent(false);
    } else {
      setIsNumberIsPresent(true);
    }
    if (containsSpecialCharacter.test(value)) {
      setIsSpecialCharPresent(false);
    } else {
      setIsSpecialCharPresent(true);
    }
    if (containsUppercase.test(value)) {
      setIsUpperCharPresent(false);
    } else {
      setIsUpperCharPresent(true);
    }
    if (containsLowerCase.test(value)) {
      setIsLowerCharPresent(false);
    } else {
      setIsLowerCharPresent(true);
    }
    if (value?.length >= 8) {
      setPassLength(false);
    } else {
      setPassLength(true);
    }
  };

  return (
    <>
      <Grid
        sx={{ display: "flex", flexDirection: "column", padding: "1rem 2rem" }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Grid item sx={flexClassStyle}>
            <Typography
              variant="h7"
              align="center"
              color="#040F3E"
              sx={{ margin: "0px 0px 10px 0px" }}
            >
              Set your Password
            </Typography>
          </Grid>
          <Grid container spacing={2}>
            <Grid xs={12} item sm={12}>
              <FormControl fullWidth size="small">
                <InputLabel>New Password</InputLabel>
                <OutlinedInput
                  sx={outlinedInputStyle}
                  id="newPassword"
                  name="newPassword"
                  value={formik.values.newPassword}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  onChange={(e) => {
                    formik.setFieldValue("newPassword", e.target.value);
                    handleValidationCheck(e.target.value);
                    setShowPassHint(true);
                  }}
                  onBlur={formik.handleBlur}
                  label="New Password"
                  error={Boolean(
                    formik.touched.newPassword && formik.errors.newPassword
                  )}
                />
                {Boolean(
                  formik.touched.newPassword && formik.errors.newPassword
                ) && (
                  <Typography variant="body2" color="error">
                    {formik.errors.newPassword}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid xs={12} item sm={12} sx={{ marginTop: "5px" }}>
              <FormControl fullWidth size="small">
                <InputLabel>Confirm Password</InputLabel>
                <OutlinedInput
                  sx={outlinedInputStyle}
                  id="ConfirmPassword"
                  value={formik.values.ConfirmPassword}
                  name="ConfirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowConfirmPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  onChange={(e) => {
                    formik.setFieldValue("ConfirmPassword", e.target.value);
                    setShowPassHint(true);
                  }}
                  onBlur={formik.handleBlur}
                  label="Confirm Password"
                  error={Boolean(
                    formik.touched.ConfirmPassword &&
                      formik.errors.ConfirmPassword
                  )}
                />
                {Boolean(
                  formik.touched.ConfirmPassword &&
                    formik.errors.ConfirmPassword
                ) && (
                  <Typography variant="body2" color="error">
                    {formik.errors.ConfirmPassword}
                  </Typography>
                )}
              </FormControl>
            </Grid>
          </Grid>

          <Grid item sx={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              type="submit"
              variant="contained"
              sx={{ textTransform: "none" }}
              disabled={isDisabled}
            >
              Save Password
            </Button>
          </Grid>
          {showPassHint && (
            <Grid
              component={Paper}
              elevation={3}
              style={{
                marginTop: "1rem",
                padding: "1rem",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {passLength ? (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CancelIcon sx={{ color: "red" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    Password must be at least 8 characters
                  </Typography>
                </Grid>
              ) : (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CheckCircleSharpIcon sx={{ color: "green" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    Password must be at least 8 characters
                  </Typography>
                </Grid>
              )}
              {isUpperCharPresent ? (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CancelIcon sx={{ color: "red" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    At least one uppercase letter (A-Z)
                  </Typography>
                </Grid>
              ) : (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CheckCircleSharpIcon sx={{ color: "green" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    At least one uppercase letter (A-Z)
                  </Typography>
                </Grid>
              )}
              {isLowerCharPresent ? (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CancelIcon sx={{ color: "red" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    At least one lowercase letter{" "}
                    <span style={{ textTransform: "none" }}>(a-z)</span>
                  </Typography>
                </Grid>
              ) : (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CheckCircleSharpIcon sx={{ color: "green" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    At least one lowercase letter{" "}
                    <span style={{ textTransform: "none" }}>(a-z)</span>
                  </Typography>
                </Grid>
              )}
              {isNumberIsPresent ? (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CancelIcon sx={{ color: "red" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    At least one number (0-9)
                  </Typography>
                </Grid>
              ) : (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CheckCircleSharpIcon sx={{ color: "green" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    At least one number (0-9)
                  </Typography>
                </Grid>
              )}
              {isSpecialCharPresent ? (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CancelIcon sx={{ color: "red" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    At least one special Character (
                    <span style={{ textTransform: "none" }}>eg</span>,@!#$%^&*)
                  </Typography>
                </Grid>
              ) : (
                <Grid item sx={{ display: "flex", padding: "5px 0px" }}>
                  <CheckCircleSharpIcon sx={{ color: "green" }} />
                  <Typography sx={{ marginLeft: "10px", fontSize: "14px" }}>
                    At least one special Character (
                    <span style={{ textTransform: "none" }}>eg</span>,@!#$%^&*)
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
        </form>
      </Grid>
    </>
  );
};
export default ResetPassword;
